<template>
  <su-page title="查询结果页">
    <el-row class="mt30" slot="content">
<!--      <div class="flex al-cn cl333 f13 mb20">
        <div>考试时间：{{exam_time || '&#45;&#45;'}}</div>
        <div class="ml30">成绩有效期：{{end_time || '&#45;&#45;'}}</div>
      </div>-->
      <el-table :data="tableData" style="width: 100%" :header-cell-style="{backgroundColor:'#F3F4F8'}">
        <el-table-column prop="name" label="姓名"></el-table-column>
        <el-table-column prop="cert_no" label="证件号"></el-table-column>
        <el-table-column prop="coursea" label="科目一">
          <template slot-scope="scope">
            <span v-if="scope.row.coursea==-1">未参与</span>
            <span v-else>{{scope.row.coursea}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="courseb" label="科目二">
          <template slot-scope="scope">
            <span v-if="scope.row.courseb==-1">未参与</span>
            <span v-else>{{scope.row.courseb}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="coursec" label="普通话">
          <template slot-scope="scope">
            <span v-if="scope.row.coursec==-1">未参与</span>
            <span v-else>{{scope.row.coursec}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="coursed" label="外语">
          <template slot-scope="scope">
            <span v-if="scope.row.coursed==-1">未参与</span>
            <span v-else>{{scope.row.coursed}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="is_pass" label="是否合格">
          <template slot-scope="scope">
            <span v-if="scope.row.is_pass==1">合格</span>
            <span v-else>不合格</span>
          </template>
        </el-table-column>
        <el-table-column prop="exam_time" label="考试时间" width="100"></el-table-column>
        <el-table-column prop="end_time" label="成绩有效期" width="100"></el-table-column>
      </el-table>
    </el-row>
  </su-page>
</template>
<script>

import {getExamResults} from "@/api/api";

export default {
  name: "myGrades",
  data() {
    return {
      tableData: [],
      exam_time:'', // 考试时间
      end_time:'', // 成绩有效期
    }
  },
  created() {

  },
  mounted() {
     this.getExamResults()
  },
  methods: {
    getExamResults() {
      getExamResults().then(response => {
        if (response.status === 200) {
          this.tableData = response.data.list || [];
          this.exam_time = response.data.exam_time;
          this.end_time = response.data.end_time;
        }
      })
    }
  }
}
</script>


<style scoped lang="scss">

</style>
